import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import useCasesStore from '../stores/casesStore';
import config from '../config';
import React from 'react';
import CurrencyIcon from './CurrencyIcon';
import useScrollToTop from '../hooks/useScrollToTop';

function Cases() {
	const { cases, loading: isLoading, error, fetchCases, wasLoaded } = useCasesStore();
	const navigate = useNavigate();
	const { t } = useTranslation();
	useScrollToTop();  // Используем хук для скролла наверх

	const handleCaseClick = (caseId) => {
		console.log(caseId);
		navigate(`/case/${caseId}`);
	};

	// Загружаем кейсы при первом рендере
	React.useEffect(() => {
		if (!wasLoaded) fetchCases();
	}, [fetchCases, wasLoaded]);

	return (
		<Container>
			<HeaderContainer>
				<div>
					<StoreTitle>Cases</StoreTitle>
					<StoreSubtitle>Open cases and get skins for Counter Strike 2</StoreSubtitle>
				</div>
			</HeaderContainer>
			{isLoading ? (
				<CasesGrid>
					{Array.from({ length: 6 }).map((_, i) => (
						<CaseCard key={i} style={{ opacity: 0.5 }}>
							<div style={{ width: '100%', height: 120, background: 'rgba(200,200,200,0.12)', borderRadius: 12, marginBottom: 8 }} />
							<div style={{ width: '60%', height: 18, background: 'rgba(200,200,200,0.12)', borderRadius: 8, margin: '0 auto 8px auto' }} />
							<div style={{ width: 48, height: 18, background: 'rgba(200,200,200,0.12)', borderRadius: 8, margin: '0 auto' }} />
						</CaseCard>
					))}
				</CasesGrid>
			) : (
				<CasesGrid>
					{cases.map(case_ => (
						<CaseCard
							key={case_.id}
							onClick={() => handleCaseClick(case_.id)}
						>
							<CaseImageWrapper>
								{case_.image && (
									<CaseImage
										src={config.getImageUrl(case_.image)}
										alt={case_.name}
										onError={(e) => {
											console.error('Image load error:', e);
											e.target.src = '/placeholder-case.png';
										}}
									/>
								)}
							</CaseImageWrapper>
							<CaseName>{case_.name}</CaseName>
							<CasePrice>
								<TokenIcon><CurrencyIcon size={18} /></TokenIcon>
								{new Intl.NumberFormat('ru-RU', {
									minimumFractionDigits: 0,
									maximumFractionDigits: 0
								}).format(parseFloat(case_.tokens))}
							</CasePrice>
						</CaseCard>
					))}
				</CasesGrid>
			)}
		</Container>
	);
}

const Container = styled.div`
	background: ${props => props.theme.background};
	padding: 0 16px;
	/* padding-top: 50px; */
`;

const HeaderContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-bottom: 24px;
`;

const StoreTitle = styled.h1`
	font-size: 24px;
	font-weight: 700;
	color: ${props => props.theme.text.primary};
	margin: 0;
	text-align: center;
`;

const StoreSubtitle = styled.div`
	font-size: 15px;
	color: ${props => props.theme.text.secondary};
	margin-top: 4px;
	text-align: center;
`;

const BalanceDisplay = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 20px;
	font-weight: 600;
	color: ${props => props.theme.text.primary};
`;

const TokenIcon = styled.span`
	font-size: 20px;
	display: flex;
	align-items: center;
	margin-right: 2px;
`;

const CasesGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
	gap: 16px;
`;

const CaseCard = styled.div`
	background: ${props => props.theme.card.background};
	border-radius: 12px;
	padding: 12px;
	display: flex;
	flex-direction: column;
	gap: 8px;
	cursor: pointer;
	transition: all 0.2s ease;
	box-shadow: 0 2px 8px ${props => props.theme.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(0, 0, 0, 0.2)'};

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 12px ${props => props.theme.type === 'light' ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.3)'};
	}

	&:active {
		transform: translateY(0);
	}
`;

const CaseImageWrapper = styled.div`
	position: relative;
	width: 100%;
	aspect-ratio: 512 / 341;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const CaseImage = styled.img`
	width: 100%;
	height: 100%;
	object-fit: contain;
	position: absolute;
	top: 0;
	left: 0;
`;

const CaseName = styled.div`
	font-size: 16px;
	font-weight: 600;
	color: ${props => props.theme.text.primary};
	text-align: center;
`;

const CasePrice = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	color: ${props => props.theme.primary};
	font-weight: 600;
`;

const LoadingText = styled.div`
	text-align: center;
	color: ${props => props.theme.text.primary};
	font-size: 18px;
	padding: 20px;
`;

const EmptyText = styled(LoadingText)`
	color: ${props => props.theme.text.secondary};
`;

export default Cases;